import React from 'react';
import Pill from 'components/Pill';
import ContentProgressCircle, { useProgressLabel } from 'components/ContentProgressCircle';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ContentProgressPill(_ref) {
  var contentName = _ref.contentName,
    progress = _ref.progress;
  var progressLabel = useProgressLabel({
    progress: progress
  });
  return /*#__PURE__*/_jsx(Pill, {
    iconRenderer: function iconRenderer() {
      return /*#__PURE__*/_jsx(ContentProgressCircle, {
        infoReadout: "hidden",
        contentName: contentName,
        progress: progress
      });
    },
    children: progressLabel
  });
}